module.exports = __webpack_public_path__ + "img/icon_bg_step_1.124a02e6.svg";